module.exports = __webpack_public_path__ + "img/pull.ac9a7a78.svg";